<template>
  <Modal
    v-if="showModal"
    ref="modal"
    :title="formData.title"
    :body="formData.body"
    :action="formData.action"
    action-color="indigo"
    @close-modal="handleCloseModal"
    @handle-action="handleAction"
  >
    <FormKit type="form" class="grid grid-cols-1 gap-8 mt-8" :actions="false" @submit="handleAction">
      <FormKit
        id="checklist_name"
        type="text"
        label="Name"
        name="checklistName"
        :value="initialName"
        placeholder="Enter checklist name"
        @input="handleNameInput($event)"
      />
    </FormKit>
  </Modal>
</template>

<script>
import Modal from '../../../shared/Modal.vue';
import { FormKit } from '@formkit/vue';

export default {
  components: {
    Modal,
    FormKit,
  },
  props: {
    taskName: { type: String, required: true },
    showModal: { type: Boolean, required: true },
    formKind: { type: String, required: true },
    initialName: { type: String, required: false },
  },
  computed: {
    formData() {
      if (this.formKind === 'new') {
        return {
          title: `New ${this.taskName} Checklist`,
          body: `Configure your ${this.taskName.toLowerCase()} checklist here`,
          action: 'Create checklist',
        };
      }
      if (this.formKind === 'edit') {
        return {
          title: `Edit ${this.taskName} Checklist`,
          body: `Configure your ${this.taskName.toLowerCase()} checklist here`,
          action: 'Update checklist',
        };
      }
      if (this.formKind === 'clone') {
        return {
          title: `Clone ${this.taskName} Checklist`,
          body: `Configure your cloned ${this.taskName.toLowerCase()} checklist here`,
          action: 'Clone checklist',
        };
      }
    },
  },
  methods: {
    handleAction() {
      this.$emit('action');
    },
    handleNameInput(event) {
      this.$emit('nameInput', event);
    },
    handleCloseModal() {
      this.$emit('closeModal');
    },
  },
};
</script>
